const URL_PARSE_BASE = "https://placeholder.local";

const parseHref = (href) => new URL(href, URL_PARSE_BASE);

const hashQuery = (hash) => {
  if (!hash || !hash.includes("?")) {
    return "";
  }
  const parts = hash.split("?");
  parts.shift();
  return parts.join("&");
};

export const readProcessInitParams = (href) => {
  const url = parseHref(href);
  const merged = new URLSearchParams(url.search);
  const fromHash = new URLSearchParams(hashQuery(url.hash));
  fromHash.forEach((value, key) => {
    merged.set(key, value);
  });
  return merged;
};

export const buildProcessDomainName = (href, cuid) => {
  const url = parseHref(href);
  const hashPath = url.hash ? url.hash.split("?")[0] : "";
  const base = `${url.origin}${url.pathname}${hashPath}`;
  if (cuid) return `${base}?cuid=${cuid}`;
  return base;
};

export const toQueryString = (params) => {
  const serialized = params.toString();
  return serialized ? `?${serialized}` : "";
};
